import type {
  AvgSpendBySegmentRequest,
  AcquisitionSourceRequest,
  AcquisitionSourceResponse,
  CustomerDetailsRequest,
  CustomerDetailsResponse,
  DrilldownCustomersRequest,
  DrilldownCustomersResponse,
  DrilldownStatsResponse,
  DrilldownTarget,
  AvgSpendBySegmentResponse,
  ChannelPerformanceRequest,
  CohortRetentionRequest,
  CohortRetentionResponse,
  ChannelPerformanceResponse,
  CustomerDirectoryRequest,
  CustomerDirectoryResponse,
  CustomerSegmentBreakdownResponse,
  CustomerStampKpisRequest,
  CustomerStampKpisResponse,
} from '../../../interface/customersReportInterface';
import {
  FETCH_CUSTOMER_STAMP_KPIS_REQUEST,
  FETCH_CUSTOMER_STAMP_KPIS_SUCCESS,
  FETCH_CUSTOMER_STAMP_KPIS_FAILURE,
  FETCH_CUSTOMER_SEGMENTS_REQUEST,
  FETCH_CUSTOMER_SEGMENTS_SUCCESS,
  FETCH_CUSTOMER_SEGMENTS_FAILURE,
  FETCH_CUSTOMER_DIRECTORY_REQUEST,
  FETCH_CUSTOMER_DIRECTORY_SUCCESS,
  FETCH_CUSTOMER_DIRECTORY_FAILURE,
  FETCH_CHANNEL_PERFORMANCE_REQUEST,
  FETCH_CHANNEL_PERFORMANCE_SUCCESS,
  FETCH_CHANNEL_PERFORMANCE_FAILURE,
  FETCH_COHORT_RETENTION_REQUEST,
  FETCH_COHORT_RETENTION_SUCCESS,
  FETCH_COHORT_RETENTION_FAILURE,
  FETCH_SEGMENT_SPEND_REQUEST,
  FETCH_SEGMENT_SPEND_SUCCESS,
  FETCH_SEGMENT_SPEND_FAILURE,
  FETCH_DRILLDOWN_STATS_REQUEST,
  FETCH_DRILLDOWN_STATS_SUCCESS,
  FETCH_DRILLDOWN_STATS_FAILURE,
  FETCH_DRILLDOWN_CUSTOMERS_REQUEST,
  FETCH_DRILLDOWN_CUSTOMERS_SUCCESS,
  FETCH_DRILLDOWN_CUSTOMERS_FAILURE,
  FETCH_ACQUISITION_SOURCE_REQUEST,
  FETCH_ACQUISITION_SOURCE_SUCCESS,
  FETCH_ACQUISITION_SOURCE_FAILURE,
  FETCH_CUSTOMER_DETAILS_REQUEST,
  FETCH_CUSTOMER_DETAILS_SUCCESS,
  FETCH_CUSTOMER_DETAILS_FAILURE,
  CLEAR_CUSTOMER_DETAILS,
} from './customersReportConstants';

export const fetchCustomerStampKpisRequest = (payload: CustomerStampKpisRequest) => ({
  type: FETCH_CUSTOMER_STAMP_KPIS_REQUEST,
  payload,
});

export const fetchCustomerStampKpisSuccess = (payload: CustomerStampKpisResponse) => ({
  type: FETCH_CUSTOMER_STAMP_KPIS_SUCCESS,
  payload,
});

export const fetchCustomerStampKpisFailure = (payload: string) => ({
  type: FETCH_CUSTOMER_STAMP_KPIS_FAILURE,
  payload,
});

export const fetchCustomerSegmentsRequest = (payload: { locationId: string }) => ({
  type: FETCH_CUSTOMER_SEGMENTS_REQUEST,
  payload,
});

export const fetchCustomerSegmentsSuccess = (payload: CustomerSegmentBreakdownResponse) => ({
  type: FETCH_CUSTOMER_SEGMENTS_SUCCESS,
  payload,
});

export const fetchCustomerSegmentsFailure = (payload: string) => ({
  type: FETCH_CUSTOMER_SEGMENTS_FAILURE,
  payload,
});

export const fetchCustomerDirectoryRequest = (payload: CustomerDirectoryRequest) => ({
  type: FETCH_CUSTOMER_DIRECTORY_REQUEST,
  payload,
});

export const fetchCustomerDirectorySuccess = (payload: CustomerDirectoryResponse) => ({
  type: FETCH_CUSTOMER_DIRECTORY_SUCCESS,
  payload,
});

export const fetchCustomerDirectoryFailure = (payload: string) => ({
  type: FETCH_CUSTOMER_DIRECTORY_FAILURE,
  payload,
});

export const fetchChannelPerformanceRequest = (payload: ChannelPerformanceRequest) => ({
  type: FETCH_CHANNEL_PERFORMANCE_REQUEST,
  payload,
});

export const fetchChannelPerformanceSuccess = (payload: ChannelPerformanceResponse) => ({
  type: FETCH_CHANNEL_PERFORMANCE_SUCCESS,
  payload,
});

export const fetchChannelPerformanceFailure = (payload: string) => ({
  type: FETCH_CHANNEL_PERFORMANCE_FAILURE,
  payload,
});

export const fetchCohortRetentionRequest = (payload: CohortRetentionRequest) => ({
  type: FETCH_COHORT_RETENTION_REQUEST,
  payload,
});

export const fetchCohortRetentionSuccess = (payload: CohortRetentionResponse) => ({
  type: FETCH_COHORT_RETENTION_SUCCESS,
  payload,
});

export const fetchCohortRetentionFailure = (payload: string) => ({
  type: FETCH_COHORT_RETENTION_FAILURE,
  payload,
});

export const fetchSegmentSpendRequest = (payload: AvgSpendBySegmentRequest) => ({
  type: FETCH_SEGMENT_SPEND_REQUEST,
  payload,
});

export const fetchSegmentSpendSuccess = (payload: AvgSpendBySegmentResponse) => ({
  type: FETCH_SEGMENT_SPEND_SUCCESS,
  payload,
});

export const fetchSegmentSpendFailure = (payload: string) => ({
  type: FETCH_SEGMENT_SPEND_FAILURE,
  payload,
});

export const fetchDrilldownStatsRequest = (payload: DrilldownTarget) => ({
  type: FETCH_DRILLDOWN_STATS_REQUEST,
  payload,
});

export const fetchDrilldownStatsSuccess = (payload: DrilldownStatsResponse) => ({
  type: FETCH_DRILLDOWN_STATS_SUCCESS,
  payload,
});

export const fetchDrilldownStatsFailure = (payload: string) => ({
  type: FETCH_DRILLDOWN_STATS_FAILURE,
  payload,
});

export const fetchDrilldownCustomersRequest = (payload: DrilldownCustomersRequest) => ({
  type: FETCH_DRILLDOWN_CUSTOMERS_REQUEST,
  payload,
});

export const fetchDrilldownCustomersSuccess = (payload: DrilldownCustomersResponse) => ({
  type: FETCH_DRILLDOWN_CUSTOMERS_SUCCESS,
  payload,
});

export const fetchDrilldownCustomersFailure = (payload: string) => ({
  type: FETCH_DRILLDOWN_CUSTOMERS_FAILURE,
  payload,
});

export const fetchAcquisitionSourceRequest = (payload: AcquisitionSourceRequest) => ({
  type: FETCH_ACQUISITION_SOURCE_REQUEST,
  payload,
});

export const fetchAcquisitionSourceSuccess = (payload: AcquisitionSourceResponse) => ({
  type: FETCH_ACQUISITION_SOURCE_SUCCESS,
  payload,
});

export const fetchAcquisitionSourceFailure = (payload: string) => ({
  type: FETCH_ACQUISITION_SOURCE_FAILURE,
  payload,
});

export const fetchCustomerDetailsRequest = (payload: CustomerDetailsRequest) => ({
  type: FETCH_CUSTOMER_DETAILS_REQUEST,
  payload,
});

export const fetchCustomerDetailsSuccess = (payload: CustomerDetailsResponse) => ({
  type: FETCH_CUSTOMER_DETAILS_SUCCESS,
  payload,
});

export const fetchCustomerDetailsFailure = (payload: string) => ({
  type: FETCH_CUSTOMER_DETAILS_FAILURE,
  payload,
});

/**
 * Dropped when the profile closes, so re-opening a row shows a spinner rather
 * than the PREVIOUS customer's profile while the new one loads - otherwise the
 * wrong name sits on screen for as long as the request takes.
 */
// Carries a `payload` it never reads: every other action in
// `CustomersReportAction` has one, and a member without it widens the union
// to `{ type: string }`, which breaks `action.payload` narrowing in EVERY
// case of the reducer - not just this one.
export const clearCustomerDetails = () => ({
  type: CLEAR_CUSTOMER_DETAILS,
  payload: null,
});

export type CustomersReportAction =
  | ReturnType<typeof fetchCustomerStampKpisRequest>
  | ReturnType<typeof fetchCustomerStampKpisSuccess>
  | ReturnType<typeof fetchCustomerStampKpisFailure>
  | ReturnType<typeof fetchCustomerSegmentsRequest>
  | ReturnType<typeof fetchCustomerSegmentsSuccess>
  | ReturnType<typeof fetchCustomerSegmentsFailure>
  | ReturnType<typeof fetchCustomerDirectoryRequest>
  | ReturnType<typeof fetchCustomerDirectorySuccess>
  | ReturnType<typeof fetchCustomerDirectoryFailure>
  | ReturnType<typeof fetchChannelPerformanceRequest>
  | ReturnType<typeof fetchChannelPerformanceSuccess>
  | ReturnType<typeof fetchChannelPerformanceFailure>
  | ReturnType<typeof fetchCohortRetentionRequest>
  | ReturnType<typeof fetchCohortRetentionSuccess>
  | ReturnType<typeof fetchCohortRetentionFailure>
  | ReturnType<typeof fetchSegmentSpendRequest>
  | ReturnType<typeof fetchSegmentSpendSuccess>
  | ReturnType<typeof fetchSegmentSpendFailure>
  | ReturnType<typeof fetchDrilldownStatsRequest>
  | ReturnType<typeof fetchDrilldownStatsSuccess>
  | ReturnType<typeof fetchDrilldownStatsFailure>
  | ReturnType<typeof fetchDrilldownCustomersRequest>
  | ReturnType<typeof fetchDrilldownCustomersSuccess>
  | ReturnType<typeof fetchDrilldownCustomersFailure>
  | ReturnType<typeof fetchCustomerDetailsRequest>
  | ReturnType<typeof fetchCustomerDetailsSuccess>
  | ReturnType<typeof fetchCustomerDetailsFailure>
  | ReturnType<typeof clearCustomerDetails>
  | ReturnType<typeof fetchAcquisitionSourceRequest>
  | ReturnType<typeof fetchAcquisitionSourceSuccess>
  | ReturnType<typeof fetchAcquisitionSourceFailure>;
